var _circle, _path, _path2, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatCallOutgoing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DEEEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3692 10.0001C12.5249 10.0261 12.6735 10.0846 12.8052 10.1717C12.9369 10.2588 13.0489 10.3726 13.1338 10.5057C13.7404 11.221 16.459 15.3829 16.3617 16.0578C16.3162 16.3763 16.0533 16.6088 15.2975 17.2357C14.9251 17.5237 14.5776 17.8424 14.2586 18.1886C14.4386 18.8525 14.6929 19.494 15.0169 20.1008C16.2459 22.4976 18.1963 24.448 20.593 25.6769C21.1998 26.0009 21.8413 26.2553 22.5052 26.4352C22.8514 26.1162 23.1702 25.7687 23.4582 25.3963C24.0901 24.638 24.3176 24.3777 24.6361 24.3322C25.311 24.2349 29.4728 26.9534 30.1882 27.5601C30.3206 27.6443 30.4339 27.7553 30.521 27.8859C30.608 28.0164 30.6669 28.1637 30.6937 28.3184C30.7203 29.1386 26.2513 32.7001 25.656 32.6799C25.608 32.6799 20.8256 32.4385 14.4811 26.1989C8.24143 19.8544 8.0013 15.077 8.00003 15.0239C7.9874 14.4426 11.5489 9.97232 12.3692 10.0001Z",
    fill: "#0473EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 18L28 13",
    stroke: "#0473EA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 12,
    width: 2,
    height: 7,
    rx: 1,
    fill: "#0473EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 12,
    width: 2,
    height: 7,
    rx: 1,
    transform: "rotate(90 29 12)",
    fill: "#0473EA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCallOutgoing);
export default __webpack_public_path__ + "static/media/chat-call-outgoing.b0d8520c8c3234b61e43a7fcc4db0aa8.svg";
export { ForwardRef as ReactComponent };